export default {
  skip15: 15,
};
